import { useTagStore } from '~/stores/tag'

import { availableAllowedSeoTags } from '~/types/seoList'

import type Tag from '~/entities/tag'
import type TagParent from '~/entities/tagParent'
import type TagType from '~/entities/tagType'

export function useInfluencerListTagSeo() {
  const { $pinia } = useNuxtApp()
  const tagStore = useTagStore($pinia)

  /**
   * Helper that extracts the target ParentTag or Tag from the supplied name string.
   *
   * @param name - The target Tag name that we are looking for.
   * @returns If found it will return the desired entity.
   */
  function getArg(name: string): Tag | TagParent | undefined {
    const parent = tagStore
      .FIND_PARENTS_WITH_NAME(name)
      .find((e) =>
        availableAllowedSeoTags.includes(
          tagStore.GET_TYPE_FROM_ID(e.type)?.name ??
            ('' as (typeof availableAllowedSeoTags)[number]),
        ),
      )

    if (parent) return parent

    const tag = tagStore
      .GET_TAGS_WITH_NAME(name)
      .find((e) =>
        availableAllowedSeoTags.includes(
          tagStore.GET_TYPE_FROM_ID(e.type)?.name ??
            ('' as (typeof availableAllowedSeoTags)[number]),
        ),
      )
    return tag
  }

  function getParamTagType(tag: Tag | TagParent): undefined | TagType {
    return tagStore.GET_TYPE_FROM_ID(tag.type)
  }

  return {
    getArg,
    getParamTagType,
  }
}
